<template>
  <div class="animated fadeIn">
    <b-card>
      <h1 class="mb-5">Help &amp; Support</h1>
      <h2>FAQ</h2>
      <p class="font-lg">
        Out FAQ is located at
        <a href="https://docs.nanome.ai/help/faq.html" target="_blank">
          docs.nanome.ai/help/faq.html</a
        >.
      </p>
    </b-card>
  </div>
</template>

<script>
export default {
  metaInfo: {
    titleTemplate: "Help & Support - %s"
  }
};
</script>
